// extracted by mini-css-extract-plugin
export default {"page":"mZ-z","cartModal":"nZ-z","checkout":"oZ-z","placeholder":"pZ-z","account":"qZ-z"};